import { render, staticRenderFns } from "./CheckboxGridList.vue?vue&type=template&id=c84efd08"
import script from "./CheckboxGridList.vue?vue&type=script&lang=js"
export * from "./CheckboxGridList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports